import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { debug } from '@bt-react/libs/Logger'
import getVideoDevices from '../getVideoDevices'
import getVideoCapabilities from '../getVideoCapabilities'

export const getCapabilitiesFromDeviceId = async (deviceId = '') => {

  let videoDevices: MediaDeviceInfo[] = []

  try {

    videoDevices = await getVideoDevices(deviceId)

  }
  catch (e) {

    debug(`Failed to fetch video devices`)

  }

  if (videoDevices.length === 0) return null

  const [ defaultDevice ] = videoDevices

  return getVideoCapabilities(defaultDevice.deviceId)

}

export default async function (deviceId = '') {

  let capabilities: MediaTrackCapabilities | null = {}

  try {

    capabilities = await getCapabilitiesFromDeviceId(deviceId)

  }
  catch (e) {

    debug(get(e, 'message', ''))

  }

  if (isEmpty(capabilities)) {

    try {

      await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: deviceId,
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      })

    }
    catch (e) {

      debug(`Failed to getUserMedia`, get(e, 'message', ''))
      return null

    }

    try {

      capabilities = await getCapabilitiesFromDeviceId(deviceId)

    }
    catch (e) {

      debug(get(e, 'message', ''))

    }

  }

  const maxWidth = get(capabilities, 'width.max', null)
  debug(`Max device width is ${maxWidth}`)
  return maxWidth

}
